import {
  DialogActions,
  IconButton,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { Formik } from "formik";
import * as yup from "yup";
import React, { useEffect, useState } from "react";
import {
  CustomSelectField,
  CustomTextField,
} from "../../../../partials/content/Forms";
import { getUserGroups } from "../../../../services/usersService";
import { onPreventEnterSubmitting } from "../../../../utils/utils";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Editor } from "primereact/editor";
import { saveTicket } from "../../../../services/crm/ticketService";
import Swal from "sweetalert2";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchUserUserGroup from "../../users/users/searchUserUserGroup";
import { Search } from "@mui/icons-material";
const TicketForm = ({
  leadID,
  customerID,
  contactID,
  inquiryID,
  subject,
  onCloseDialog,
  onSaveConfirm,
}) => {
  const [userGroups, setUserGroups] = useState([]);
  const [users, setUsers] = useState([
    {
      firstName: "",
      lastName: "",
    },
  ]);
  let ticketData = {
    ID: 0,
    leadID: leadID,
    customerID: customerID,
    contactID: contactID,
    subject: subject,
    inquiryID: inquiryID,
    priorityID: 0,
    groupID: 0,
    groupName: "",
    userID: 0,
    userName: "",
    message: "",
  };
  const [openSearchUserUserGroup, setOpenSearchUserUserGroup] = useState(false);

  useEffect(() => {
    getUserGroupData();
  }, []);

  const ticketFormSchema = yup.object().shape({
    ID: yup.number(),
    priorityID: yup.number().min(1, "Priority is required"),
    groupID: yup.number(),
    groupName: yup.string().required("Service is required"),
    userID: yup.number(),
    userName: yup.string(),
    message: yup.string(),
  });
  return (
    <Formik
      initialValues={ticketData}
      validationSchema={ticketFormSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Ticket ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveTicket(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onSaveConfirm();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <Autocomplete
                disableClearable={true}
                inputValue={values.groupName}
                options={userGroups}
                getOptionLabel={(option) => option.groupName}
                onChange={(event, value) => {
                  if (value.ID && value.ID !== null) {
                    setFieldValue("groupID", value.ID);
                    setFieldValue("groupName", value.groupName);
                    setFieldValue("userID", 0);
                    setFieldValue("userName", "");
                  }
                }}
                onInputChange={(event, value) => {
                  setFieldValue("groupName", value);
                }}
                renderInput={(params) => (
                  <TextField
                    className="kt-width-full"
                    {...params}
                    label="Service"
                    variant="outlined"
                    size="small"
                    helperText={touched.groupName && errors.groupName}
                    error={Boolean(touched.groupName && errors.groupName)}
                  />
                )}
              />
              <CustomSelectField
                label="Priority"
                propertyName="priorityID"
                onBlur={handleBlur}
                onChange={handleChange}
                values={values}
                touched={touched}
                errors={errors}
                options={[
                  { value: 0, label: "" },
                  { value: 1, label: "High" },
                  { value: 2, label: "Medium" },
                  { value: 3, label: "Low" },
                ]}
                size="small"
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <CustomTextField
                label="Assigned To"
                margin="none"
                inputType="text"
                propertyName="userName"
                onBlur={handleBlur}
                onChange={handleChange}
                values={values}
                touched={touched}
                errors={errors}
                endAdornment={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setOpenSearchUserUserGroup(true);
                        }}
                        aria-label="Search User"
                        edge="end"
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                  readOnly: true,
                }}
                size="small"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Editor
                placeholder="Type your messages here..."
                style={{ height: "320px" }}
                onTextChange={(e) => {
                  setFieldValue("message", e.htmlValue);
                }}
                value={values.message}
              />
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
          <DialogLayout
            open={openSearchUserUserGroup}
            title="Search User"
            onCloseDialog={handleCloseSearchUserUserGroup}
            maxWIdth="lg"
          >
            {values.groupID > 0 ? (
              <SearchUserUserGroup
                groupID={values.groupID}
                onSelectUser={(user) => {
                  setFieldValue("userID", user.ID);
                  setFieldValue(
                    "userName",
                    user.firstName + " " + user.lastName
                  );
                  handleCloseSearchUserUserGroup();
                }}
              />
            ) : (
              <p>Please Select Service</p>
            )}

            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={handleCloseSearchUserUserGroup}
              >
                <i className="fas fa-window-close"></i>
                Cancel
              </button>
            </DialogActions>
          </DialogLayout>
        </form>
      )}
    </Formik>
  );

  function handleCloseSearchUserUserGroup() {
    setOpenSearchUserUserGroup(false);
  }

  async function getUserGroupData() {
    const response = await getUserGroups();
    setUserGroups(response.data);
  }
};

export default TicketForm;
